module.exports = __webpack_public_path__ + "static/media/exercise_atlas_coming_soon.d127d46e.png";